import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { PasswordService } from './forgot-pwd.component.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
	selector: 'app-forgot-pwd',
	templateUrl: './forgot-pwd.component.html'
})

export class ForgotPwdComponent implements OnInit {
	email: string = "";
	userId!: string;
	resetCode!: string;
	isResetMode = false;
	hideForm = false;
	password = '';
	confirmPassword = '';
	showPassword = false;
	showConfirmPassword = false;
	
	// Loading states
	isSubmitting = false;
	passwordUpdateSuccess = false;
	projectId: string | null = null;
	constructor(
		private route: ActivatedRoute,
		private toastr: ToastrService,
		private router: Router, 
		private modelService: PasswordService
	) {}

	ngOnInit(): void {
		this.route.params.subscribe(params => {
			if (params['userId'] && params['resetCode']) {
				this.isResetMode = true;
				this.userId = params['userId'];
				this.resetCode = params['resetCode'];
				this.projectId = params['projectId'] || null;
			} else {
				this.isResetMode = false;
			}
		});
	}
	resetPassword() {
		if (!this.email || this.email.trim() === '') {
			this.toastr.error('Please enter your email address', 'Error');
			return;
		}
		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		if (!emailRegex.test(this.email)) {
			this.toastr.error('Please enter a valid email address', 'Error');
			return;
		}

		this.isSubmitting = true;

		this.modelService.sendReset(this.email).subscribe({
			next: (res) => {
				console.log('Reset email sent successfully', res);
				this.toastr.success(
					'Password reset link has been sent to your email', 
					'Success'
				);
				
				
				this.email = '';
				
				
				setTimeout(() => {
					this.router.navigate(['/login']);
				}, 3000);
			},
			error: (err) => {
				console.error('Reset email error:', err);

				if (err.status === 404) {
					this.toastr.error('No account found with this email address', 'User Not Found');
				} else if (err.status === 400) {
					this.toastr.error('Email is required', 'Bad Request');
				} else if (err.status === 401) {
					this.toastr.error('Unauthorized access', 'Unauthorized');
				} else if (err.status === 500) {
					this.toastr.error('Server error. Please try again later', 'Error');
				} else {
					this.toastr.error(
						err.error?.message || 'Something went wrong. Please try again', 
						'Error'
					);
				}
			},
			complete: () => {
				this.isSubmitting = false;
			}
		});
	}

	
	updatePassword() {
		if (!this.password || this.password.trim() === '') {
			this.toastr.error('Please enter a new password', 'Error');
			return;
		}

		if (this.password.length < 8) {
			this.toastr.error('Password must be at least 8 characters long', 'Error');
			return;
		}

		if (!this.confirmPassword || this.confirmPassword.trim() === '') {
			this.toastr.error('Please confirm your password', 'Error');
			return;
		}

		if (this.password !== this.confirmPassword) {
			this.toastr.error('Passwords do not match', 'Error');
			return;
		}

		this.isSubmitting = true;

		this.modelService.resetPasswordConfirm(
			this.userId, 
			this.resetCode, 
			this.password
		).subscribe({
			next: (res) => {
				this.passwordUpdateSuccess = true;
				this.isSubmitting = false;
				this.hideForm = true;
				this.toastr.success(
					'Password updated successfully! Redirecting to login...', 
					'Success'
				);
				this.password = '';
				this.confirmPassword = '';
				this.showPassword = false;
				this.showConfirmPassword = false;

				setTimeout(() => {
					if (this.projectId) {
						localStorage.setItem('invite_project_id', this.projectId);
					}
					this.router.navigate(['/login']);
				}, 1000);
			},
			error: (err) => {
				console.error('Password update error:', err);
				
				const errorMessage = err.error?.message || '';

				if (errorMessage.includes('expired') || err.status === 410) {
					this.toastr.error(
						'Reset link has expired. Please request a new one.', 
						'Link Expired'
					);
				
					setTimeout(() => {
						this.router.navigate(['/forgot-password']);
					}, 2000);
				} else if (errorMessage.includes('Invalid reset code') || err.status === 400) {
					this.toastr.error(
						'Invalid reset link. Please request a new one.', 
						'Invalid Link'
					);
					setTimeout(() => {
						this.router.navigate(['/forgot-password']);
					}, 2000);
				} else if (errorMessage.includes('User not found') || err.status === 404) {
					this.toastr.error('User not found', 'Error');
				} else if (err.status === 500) {
					this.toastr.error('Server error. Please try again later', 'Error');
				} else {
					this.toastr.error(
						errorMessage || 'Failed to update password. Please try again.', 
						'Error'
					);
				}
			},
			complete: () => {
				this.isSubmitting = false;
			}
		});
	}

	navigateToLogin() {
		this.router.navigate(['/login']);
	}
}